import React from 'react';
import { Paper, Slide, Box } from '@mui/material';

function PaperSheet({ children }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Slide appear={true} in={true} direction="down" mountOnEnter={true}>
        <Paper
          elevation={4}
          sx={(theme) => ({
            maxWidth: '500px',
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingTop: '16px',
            paddingBottom: '16px',
            marginTop: theme.spacing(3),
          })}
        >
          {children}
        </Paper>
      </Slide>
    </Box>
  );
}

export default PaperSheet;
